var _path, _path2, _path3, _path4, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLearningHat(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 60,
    height: 60,
    viewBox: "0 0 60 60",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M31.4772 0.303206C30.5339 -0.101069 29.4661 -0.101069 28.5228 0.303206L2.2728 11.5532C0.893988 12.1441 0 13.4999 0 15C0 16.5001 0.893988 17.8559 2.2728 18.4468L12.1889 22.6966C12.5495 22.288 13.0015 21.9552 13.5228 21.7318L28.5228 15.3033C30.4264 14.4874 32.631 15.3692 33.4468 17.2729C34.2626 19.1765 33.3808 21.381 31.4772 22.1968L21.2501 26.5799L28.5228 29.6968C29.4661 30.1011 30.5339 30.1011 31.4772 29.6968L57.7272 18.4468C59.106 17.8559 60 16.5001 60 15C60 13.4999 59.106 12.1441 57.7272 11.5532L31.4772 0.303206Z",
    fill: "url(#lh-paint-01)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M4.91267 27.7377L11.25 30.4537V45.8349C9.96461 45.5434 8.65145 45.3253 7.31516 45.1852C5.55352 45.0004 4.16136 43.6083 3.97665 41.8466C3.82674 40.4169 3.75 38.9664 3.75 37.4994C3.75 34.1374 4.15279 30.8681 4.91267 27.7377Z",
    fill: "url(#lh-paint-01)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M27.3748 54.6469C24.8516 52.1733 21.9438 50.094 18.75 48.5066V33.668L25.5684 36.5902C28.3983 37.803 31.6017 37.803 34.4316 36.5902L55.0873 27.7377C55.8472 30.8681 56.25 34.1374 56.25 37.4994C56.25 38.9664 56.1733 40.4169 56.0233 41.8466C55.8386 43.6083 54.4465 45.0004 52.6848 45.1852C44.9117 46.0002 37.9214 49.4549 32.6252 54.6469C31.167 56.0764 28.833 56.0764 27.3748 54.6469Z",
    fill: "url(#lh-paint-01)"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M15 59.9999C17.0711 59.9999 18.75 58.321 18.75 56.2499V48.5066C16.3926 47.335 13.8794 46.4313 11.25 45.8349V56.2499C11.25 58.321 12.9289 59.9999 15 59.9999Z",
    fill: "url(#lh-paint-01)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "lh-paint-01",
    x1: -1.67213e-7,
    y1: 45.5999,
    x2: 62.1523,
    y2: 39.5645,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#05456D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0A7AC0"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "lh-paint-02",
    x1: 60,
    y1: 15.9773,
    x2: -1.97682,
    y2: 20.9807,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#06D6A0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#26B3C5"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLearningHat);
export default __webpack_public_path__ + "static/media/learning-hat.29a418c400c3e144c0e7d42ee9c71b84.svg";
export { ForwardRef as ReactComponent };